import { objectEntriesTyped } from '@bos/utils';

import type { ClientDocumentCategoryV5 } from '../../../../../../api/generated/cz.partners.bank.backofficegateway.documents';
import type { AppSelectOption } from '../../../../../../components/AppSelectComboboxField';
import { useClientDocumentCategoryTranslationMap } from '../../../../../../components/documents/hooks/useClientDocumentCategoryTranslationMap';
import { filterOptionsByAvailableValues } from '../../../../../../helpers/filterOptionsByAvailableValues';

export const useClientDocumentCategorySelectOptions = (
	availableCategories: ClientDocumentCategoryV5[] | undefined,
) => {
	const categoryTranslationMap = useClientDocumentCategoryTranslationMap();

	const allOptions: AppSelectOption[] = objectEntriesTyped(
		categoryTranslationMap,
	).map(([value, translation]) => ({
		value,
		text: translation,
	}));

	const options = filterOptionsByAvailableValues(
		allOptions,
		availableCategories,
	);

	return options;
};
